

// src/styles/colors.js
export const Colors = {
    '$dark': '#3f3f3f',
    '$headerColor': '#fff',
    '$menuItemText': '#efb713',
    '$menuItemIcon': '#efb713',
    '$buttonSelectedColor': '#4f4f50',
    '$buttonYellowColor': '#D19C00',
    '$buttonGoldColor': '#D19C00',
    '$buttonLightGreyColor': '#BDBCBC',
    '$button-color': '#595a5c',
    '$menu-button-selected': '#595a5c',

    // Menu
    '$menuBackground': '#efb713',
    '$menuButton': '#d19c00',
    '$menuButtonSelected': '#595a5c',
    '$menuTextColor': '#fff',
    '$greyText': '#A8A8A8',
    '$textBackground': '#F1F1F1',

    // Course
    '$completedColor': '#efb713',
    '$inProgressColor': '#595a5c',
    '$notStartedColor': '#d7d5d5',
    '$courseGreen': '#69e185',


    // Page
    '$pageTitle': '#595a5c',
    '$subTitle': '#a8a8a8',
    '$lightGrey': 'rgba(168, 168, 168, 0.16)',

    '$colorLightBlue': '#79b7ee',
    '$colorLink': '#007bff',
    '$colorWarning': '#ffc107',

    '$colorRed': 'red',
    '$grey1': 'grey',
    '$darkGrey': '#3f3f3f',
    '$colorSuccess': '#69e185',
    '$successColor': '#69e185',

    '$borderColor': '#d19c00',


    '$themeLight': '#ffffff',
    '$themeText': '#a8dadc',
    '$themeTitle': '#457b9d',
    '$themeDark': '#020518',
    '$themeRed': '#e63946',
    '$themePink': '#FFCCCC',
    '$DefaultColor': '#f1faee',

    // Common colors
    '$white': '#ffffff',
    '$gray-50': '#f9fafb',
    '$gray-100': '#f8f9fa',
    '$gray-300': '#dee2e6',
    '$gray-500': '#adb5bd',
    '$gray-700': '#495057',
    '$error': '#dc3545',
    '$error-light': '#f8d7da',
    '$success': '#69e185',
    '$primary-color': '#efb713',


    '$GraphBackground1': '#A1D6B2',
    '$GraphBackground2': '#F5D471',
    '$GraphBackground3': '#E3E2E2',
    '$GraphBackground4': '#C8A8E9',
    '$GraphBackground5': '#FFB084',
    '$GraphBackground6': '#87CEEB',
    '$GraphBackground7': '#F4A6CD',
    '$GraphBackground8': '#B0E0E6',
    '$GraphBackground9': '#FFDAB9',
    '$GraphBackground10': '#DDA0DD',
    '$GraphColor1': '#efb713',
    '$GraphColor2': '#595a5c',
    '$GraphColor3': '#d7d5d5',
    '$GraphBorder': '#9B9C9E',

    // UI colors for components
    '$textPrimary': '#333333',
    '$textSecondary': '#666666',
    '$backgroundPrimary': '#ffffff',
    '$backgroundSecondary': '#f8f9fa',
    '$borderLight': '#e0e0e0',

    // Status colors for templates
    '$publicColor': '#4caf50',
    '$privateColor': '#ff9800',
    '$readyColor': '#2196f3',
    '$draftColor': '#9e9e9e',


    '$color-success': '#69e185',
    '$failedColor':'#FF6666',

    // Rejection/Error colors
    '$rejectionRed': '#dc2626',
    '$rejectionRedLight': '#fef2f2',
    '$rejectionRedDark': '#991b1b',
    '$rejectionRedDarker': '#7f1d1d',
    '$rejectionRedTransparent': 'rgba(220, 38, 38, 0.15)',
    '$rejectionRedShadow': 'rgba(220, 38, 38, 0.3)',
    '$errorHoverBg': 'rgba(220, 53, 69, 0.1)',

    // Border colors
    '$borderDefault': '#eee',
    '$borderLightGray': '#eaeaea',
    '$borderMediumGray': '#c4c4c4',
    '$borderDashedGray': '#ccc',
    '$borderDashedHover': '#aaa',

    // Background colors
    '$backgroundHoverLight': '#f9f9f9',
    '$backgroundWhiteOff': '#fdfdfd',

    // Text colors (additional)
    '$textDark': '#333',
    '$textDarker': '#222',
    '$textMediumGray': '#555',
    '$textLightGray': '#777',
    '$textLighterGray': '#888',

    // Status colors (additional)
    '$statusWaiting': '#ffa000'
};
